module.exports = __webpack_public_path__ + "static/img/1.679f1654.jpg";